// src/hooks/usePageContent.js
import { useState } from 'react';
import { getAllPage } from '../services/pageContentService';
import  {getUserShopInformation} from  "../services/shopUserService";

const usePageAll = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);
    const [shop, setAvailableShop] = useState([]);

    const fetchPage = async () => {
        setStatus('loading');
        setError('');

        try {
            const response = await getAllPage();

            if (response?.status !== 'Error') {
                setData(response.data ?? response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const fetchUserShop = async () => {
        setStatus("loading");
        setError("")
        if(localStorage.getItem("serviceToken") != null){
                try {
                const response = await getUserShopInformation();

                if (response?.status !== "Error") {
                    setAvailableShop(response.data ?? response); // depending on API shape
                    setStatus("done");
                } else {
                    setStatus("error");
                    setError(response?.message || "Something went wrong");
                }
            } catch (err) {
                setStatus("error");
                setError(err?.message || "Something went wrong");
            }
        }
       
    }

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchPage,
        fetchUserShop,
        data,
        shop,
        status,
        error,
        resetStatus
    };
};

export default usePageAll;
